import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ApiErrorTrace {
  uuid: string;
  url: string;
  method: string;
  requestPayload: any;
  response: any;
  timestamp: string;
}

@Injectable({
  providedIn: 'root'
})
export class ErrorTraceService {
  private readonly lastErrorTraceSubject = new BehaviorSubject<ApiErrorTrace | null>(null);
  readonly lastErrorTrace$ = this.lastErrorTraceSubject.asObservable();

  setLastErrorTrace(trace: ApiErrorTrace): void {
    this.lastErrorTraceSubject.next(trace);
  }

  getLastErrorTrace(): ApiErrorTrace | null {
    return this.lastErrorTraceSubject.value;
  }

  clear(): void {
    this.lastErrorTraceSubject.next(null);
  }
}
